import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import './style.scss'

const AdminLayout: React.FC = () => {
  return (
    <div className='admin-layout'>
      <Sidebar />
      <div className='content-wrap'>
        <Header />
        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;
